import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import './navbar.css';
import { useTranslation } from 'react-i18next';
import { FaBars, FaTimes } from 'react-icons/fa';

const Navbar = (props) => {
  const { t, i18n } = useTranslation();
  const [link5DropdownVisible, setLink5DropdownVisible] = useState(false);
  const [langDropdownOpen, setLangDropdownOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  return (
    <header className='navbar8-container1'>
      <header data-thq='thq-navbar' className='navbar8-navbar-interactive'>
        <img alt={props.imageAlt} src={props.imageSrc} className='navbar8-image' />
        <div data-thq='thq-navbar-nav'>
          <div
            className='navbar8-buttons1'
            style={{
              display: 'flex',
              flexDirection: 'row',
              gap: '0.5rem',
              justifyContent: 'center',
              width: '100%',
              padding: '0 0.5rem',
              maxWidth: '100vw',
            }}
          >
            {/* Desktop Menu (hidden on mobile) */}
            <div className='navbar8-desktop-menu'>
              <button
                className='navbar8-action11 thq-button-animated thq-button-filled'
                style={{ flex: '1', minWidth: '100px', maxWidth: '150px' }}
              >
                <a
                  href='https://t.me/schengen_visa_slot_bot?start=we_01_0000'
                  target='_blank'
                  rel='noreferrer noopener'
                  className='navbar8-link4'
                  style={{ width: '100%' }}
                >
                  {props.action1 ?? (
                    <Fragment>
                      <span className='navbar8-text25'>{t('navbar.getStarted')}</span>
                    </Fragment>
                  )}
                </a>
              </button>
              <a
                href='https://wa.me/818074115851?text=I%27m%20interested%20in%20Application%20Assistance'
                target='_blank'
                rel='noreferrer noopener'
                className='navbar8-action21 thq-button-animated thq-button-outline'
                style={{ flex: '1', minWidth: '100px', maxWidth: '150px' }}
              >
                <span>
                  {props.action2 ?? (
                    <Fragment>
                      <span className='navbar8-text21'>{t('navbar.contactUs')}</span>
                    </Fragment>
                  )}
                </span>
              </a>
              <div
                className='navbar8-lang-switcher navbar8-lang-switcher-desktop'
                style={{ position: 'relative', marginLeft: '1rem' }}
              >
                <button
                  className='navbar8-lang-btn'
                  onClick={() => setLangDropdownOpen((open) => !open)}
                  aria-label='Switch Language'
                  style={{
                    background: 'transparent',
                    border: 'none',
                    fontSize: '1.5rem',
                    cursor: 'pointer',
                    padding: '0.25rem 0.5rem',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {i18n.language === 'zh' ? '🇨🇳' : '🇬🇧'}
                </button>
                {langDropdownOpen && (
                  <div
                    className='navbar8-lang-dropdown'
                    style={{
                      position: 'absolute',
                      top: '110%',
                      right: 0,
                      background: '#fff',
                      border: '1px solid #ccc',
                      borderRadius: 6,
                      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                      zIndex: 100,
                      minWidth: 48,
                    }}
                  >
                    <button
                      className='navbar8-lang-option'
                      onClick={() => {
                        i18n.changeLanguage('en');
                        setLangDropdownOpen(false);
                      }}
                      style={{
                        background: 'transparent',
                        border: 'none',
                        width: '100%',
                        padding: '0.5rem 1rem',
                        textAlign: 'left',
                        fontSize: '1.25rem',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                      aria-label={t('navbar.english')}
                    >
                      <span style={{ marginRight: 8 }}>🇬🇧</span> {t('navbar.english')}
                    </button>
                    <button
                      className='navbar8-lang-option'
                      onClick={() => {
                        i18n.changeLanguage('zh');
                        setLangDropdownOpen(false);
                      }}
                      style={{
                        background: 'transparent',
                        border: 'none',
                        width: '100%',
                        padding: '0.5rem 1rem',
                        textAlign: 'left',
                        fontSize: '1.25rem',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                      aria-label={t('navbar.chinese')}
                    >
                      <span style={{ marginRight: 8 }}>🇨🇳</span> {t('navbar.chinese')}
                    </button>
                  </div>
                )}
              </div>
            </div>
            {/* Hamburger Icon (mobile only) */}
            <div className='navbar8-burger-menu' onClick={() => setMobileMenuOpen(true)}>
              <FaBars size={28} />
            </div>
          </div>
        </div>
        {link5DropdownVisible === true && (
          <div className='navbar8-container6 thq-box-shadow'>
            <div className='navbar8-link5-menu-list'>
              <a href={props.linkUrlPage1}>
                <div className='navbar8-menu-item5'>
                  <img
                    alt={props.page1ImageAlt}
                    src={props.page1ImageSrc}
                    className='navbar8-page1-image2 thq-img-ratio-1-1'
                  />
                  <div className='navbar8-content5'>
                    <span className='navbar8-page12 thq-body-large'>
                      {props.page1 ?? (
                        <Fragment>
                          <span className='navbar8-text20'>{t('navbar.home')}</span>
                        </Fragment>
                      )}
                    </span>
                    <span className='thq-body-small'>
                      {props.page1Description ?? (
                        <Fragment>
                          <span className='navbar8-text18'>Learn more about our visa assistant service</span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
              </a>
              <a href={props.linkUrlPage2}>
                <div className='navbar8-menu-item6'>
                  <img
                    alt={props.page2ImageAlt}
                    src={props.page2ImageSrc}
                    className='navbar8-page2-image2 thq-img-ratio-1-1'
                  />
                  <div className='navbar8-content6'>
                    <span className='navbar8-page22 thq-body-large'>
                      {props.page2 ?? (
                        <Fragment>
                          <span className='navbar8-text14'>{t('navbar.services')}</span>
                        </Fragment>
                      )}
                    </span>
                    <span className='thq-body-small'>
                      {props.page2Description ?? (
                        <Fragment>
                          <span className='navbar8-text22'>
                            Discover our range of services for visa appointment notifications
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
              </a>
              <a href={props.linkUrlPage3}>
                <div className='navbar8-menu-item7'>
                  <img
                    alt={props.page3ImageAlt}
                    src={props.page3ImageSrc}
                    className='navbar8-page3-image2 thq-img-ratio-1-1'
                  />
                  <div className='navbar8-content7'>
                    <span className='navbar8-page32 thq-body-large'>
                      {props.page3 ?? (
                        <Fragment>
                          <span className='navbar8-text23'>{t('navbar.testimonials')}</span>
                        </Fragment>
                      )}
                    </span>
                    <span className='thq-body-small'>
                      {props.page3Description ?? (
                        <Fragment>
                          <span className='navbar8-text15'>Read what our customers have to say about our service</span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
              </a>
              <a href={props.linkUrlPage4}>
                <div className='navbar8-menu-item8'>
                  <img
                    alt={props.page4ImageAlt}
                    src={props.page4ImageSrc}
                    className='navbar8-page4-image2 thq-img-ratio-1-1'
                  />
                  <div className='navbar8-content8'>
                    <span className='navbar8-page42 thq-body-large'>
                      {props.page4 ?? (
                        <Fragment>
                          <span className='navbar8-text19'>{t('navbar.contact')}</span>
                        </Fragment>
                      )}
                    </span>
                    <span className='thq-body-small'>
                      {props.page4Description ?? (
                        <Fragment>
                          <span className='navbar8-text16'>Get in touch with us for any inquiries or assistance</span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
              </a>
            </div>
          </div>
        )}
      </header>
      {link5DropdownVisible === true && (
        <div onClick={() => setLink5DropdownVisible(false)} className='navbar8-container7'></div>
      )}
      {/* Mobile Overlay Menu */}
      {mobileMenuOpen && (
        <div className='navbar8-mobile-menu'>
          <div className='navbar8-mobile-menu-header'>
            <img alt={props.imageAlt} src={props.imageSrc} className='navbar8-image' style={{ height: 40 }} />
            <button
              className='navbar8-mobile-menu-close'
              onClick={() => setMobileMenuOpen(false)}
              style={{ background: 'none', border: 'none', fontSize: 28 }}
            >
              <FaTimes />
            </button>
          </div>
          <div className='navbar8-mobile-menu-items'>
            <a
              href='https://t.me/schengen_visa_slot_bot?start=we_01_0000'
              target='_blank'
              rel='noreferrer noopener'
              className='navbar8-link4'
              style={{ width: '100%', marginBottom: 16 }}
            >
              <span className='navbar8-text25'>{t('navbar.getStarted')}</span>
            </a>
            <a
              href='https://wa.me/818074115851?text=I%27m%20interested%20in%20Application%20Assistance'
              target='_blank'
              rel='noreferrer noopener'
              className='navbar8-link4'
              style={{ width: '100%', marginBottom: 16 }}
            >
              <span className='navbar8-text21'>{t('navbar.contactUs')}</span>
            </a>
            <div className='navbar8-lang-switcher' style={{ position: 'relative', marginTop: 16 }}>
              <button
                className='navbar8-lang-btn'
                onClick={() => setLangDropdownOpen((open) => !open)}
                aria-label='Switch Language'
                style={{
                  background: 'transparent',
                  border: 'none',
                  fontSize: '1.5rem',
                  cursor: 'pointer',
                  padding: '0.25rem 0.5rem',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                {i18n.language === 'zh' ? '🇨🇳' : '🇬🇧'}
              </button>
              {langDropdownOpen && (
                <div
                  className='navbar8-lang-dropdown'
                  style={{
                    position: 'absolute',
                    top: '110%',
                    left: 0,
                    background: '#fff',
                    border: '1px solid #ccc',
                    borderRadius: 6,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                    zIndex: 100,
                    minWidth: 48,
                  }}
                >
                  <button
                    className='navbar8-lang-option'
                    onClick={() => {
                      i18n.changeLanguage('en');
                      setLangDropdownOpen(false);
                    }}
                    style={{
                      background: 'transparent',
                      border: 'none',
                      width: '100%',
                      padding: '0.5rem 1rem',
                      textAlign: 'left',
                      fontSize: '1.25rem',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                    aria-label={t('navbar.english')}
                  >
                    <span style={{ marginRight: 8 }}>🇬🇧</span> {t('navbar.english')}
                  </button>
                  <button
                    className='navbar8-lang-option'
                    onClick={() => {
                      i18n.changeLanguage('zh');
                      setLangDropdownOpen(false);
                    }}
                    style={{
                      background: 'transparent',
                      border: 'none',
                      width: '100%',
                      padding: '0.5rem 1rem',
                      textAlign: 'left',
                      fontSize: '1.25rem',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                    aria-label={t('navbar.chinese')}
                  >
                    <span style={{ marginRight: 8 }}>🇨🇳</span> {t('navbar.chinese')}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

Navbar.defaultProps = {
  link2Url: 'https://www.teleporthq.io',
  linkUrlPage2: 'https://www.teleporthq.io',
  page3ImageSrc:
    'https://images.unsplash.com/photo-1491487856674-5faf18259360?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc1MDIyMzk3N3w&ixlib=rb-4.1.0&q=80&w=1080',
  linkUrlPage3: 'https://www.teleporthq.io',
  link4: undefined,
  page2: undefined,
  linkUrlPage4: 'https://www.teleporthq.io',
  logoSrc:
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/84ec08e8-34e9-42c7-9445-d2806d156403/fac575ac-7a41-484f-b7ac-875042de11f8?org_if_sml=1&force_format=original',
  page3Description: undefined,
  page4Description: undefined,
  link2: undefined,
  link1Url: 'https://www.teleporthq.io',
  page1ImageSrc:
    'https://images.unsplash.com/photo-1520069853334-85e555651e6f?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc1MDIyMzk3Nnw&ixlib=rb-4.1.0&q=80&w=1080',
  page1Description: undefined,
  logoAlt: 'Company Logo',
  page4: undefined,
  imageSrc: '/visa-slot-logo.svg',
  page1: undefined,
  page2ImageAlt: 'Image representing Services page',
  linkUrlPage1: 'https://www.teleporthq.io',
  page1ImageAlt: 'Image representing Home page',
  action2: undefined,
  page2Description: undefined,
  page4ImageAlt: 'Image representing Contact page',
  page3: undefined,
  link3: undefined,
  page4ImageSrc:
    'https://images.unsplash.com/photo-1727600511816-78461105fbdb?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc1MDIyMzk3N3w&ixlib=rb-4.1.0&q=80&w=1080',
  page2ImageSrc:
    'https://images.unsplash.com/photo-1741649416158-0e72ddcffadb?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc1MDIyMzk3N3w&ixlib=rb-4.1.0&q=80&w=1080',
  action1: undefined,
  page3ImageAlt: 'Image representing Testimonials page',
  imageAlt: 'image',
  link3Url: 'https://www.teleporthq.io',
  link1: undefined,
};

Navbar.propTypes = {
  link2Url: PropTypes.string,
  linkUrlPage2: PropTypes.string,
  page3ImageSrc: PropTypes.string,
  linkUrlPage3: PropTypes.string,
  link4: PropTypes.element,
  page2: PropTypes.element,
  linkUrlPage4: PropTypes.string,
  logoSrc: PropTypes.string,
  page3Description: PropTypes.element,
  page4Description: PropTypes.element,
  link2: PropTypes.element,
  link1Url: PropTypes.string,
  page1ImageSrc: PropTypes.string,
  page1Description: PropTypes.element,
  logoAlt: PropTypes.string,
  page4: PropTypes.element,
  imageSrc: PropTypes.string,
  page1: PropTypes.element,
  page2ImageAlt: PropTypes.string,
  linkUrlPage1: PropTypes.string,
  page1ImageAlt: PropTypes.string,
  action2: PropTypes.element,
  page2Description: PropTypes.element,
  page4ImageAlt: PropTypes.string,
  page3: PropTypes.element,
  link3: PropTypes.element,
  page4ImageSrc: PropTypes.string,
  page2ImageSrc: PropTypes.string,
  action1: PropTypes.element,
  page3ImageAlt: PropTypes.string,
  imageAlt: PropTypes.string,
  link3Url: PropTypes.string,
  link1: PropTypes.element,
};

export default Navbar;
